module.exports = __webpack_public_path__ + "svg/illustration-business-call.3fe42b2.svg";